module.exports = __webpack_public_path__ + "static/media/Mobile_Terrain_Scanning.882d2c6b.pdf";